module.exports = __webpack_public_path__ + "static/media/aqua expert.8570177e.jpg";